<div
    ngGrid
    [rendererOptions]="_renderOpts"
    [selectTemplate]="_selectTpl"
    (inflate)="_onInflate()"
    #grid="grid"
>
    <ng-template
        gridContent
        data-type="grid"
    >
        <div></div>
    </ng-template>

    <ng-template
        gridContent
        data-type="row"
    >
        <div></div>
    </ng-template>

    <ng-template
        gridContent
        data-type="cell"
        data-id="header"
        let-c="c"
        let-ctx="ctx"
    >
        <div [ngSwitch]="c.ctx.type">
            <div
                *ngSwitchCase="_ColumnType.NAME"
                class="control-header"
            >
                <!--maybe make into a component-->
                <div class="roster-type-tab-list">
                    <button
                        class="btn bg-transparent roster-type-tab"
                        [class.active]="rosterType === _RosterType.TEAM"
                        (click)="_onRosterTypeClick(_RosterType.TEAM)"
                    >
                        {{ _i18n._7443_TEAM | translate | titlecase }}
                    </button>
                    <button
                        class="btn bg-transparent roster-type-tab"
                        [class.active]="rosterType === _RosterType.OTHER"
                        (click)="_onRosterTypeClick(_RosterType.OTHER)"
                    >
                        {{ _i18n._9603_OTHER | translate }}
                    </button>
                </div>
                <div class="filter">
                    <div class="filter-button">
                        {{ _i18n._7360_FILTER | translate }}
                        <cmps-icon
                            class="filter-icon"
                            svgIcon="text"
                        ></cmps-icon>
                    </div>
                </div>
            </div>
            <div
                *ngSwitchCase="_ColumnType.OVERALL_COACHING_PERCENT"
                class="ccg-coverage-col"
            >
                <span>{{
                    _i18n._9599_OVERALL_COACHING_PERCENT | translate
                }}</span>
                <!--for 'dummy' see makeColumns in coaching-coverage.function-->
                <div
                    class="ccg-sort"
                    *ngIf="c.id === 'dummy'"
                >
                    <button
                        class="btn bg-transparent p-0"
                        [attr.data-e2e]="'button-sort-' + c.id"
                        (click)="_onSortClick(c.children[0])"
                    >
                        <cmps-icon
                            [svgIcon]="
                                sortDefs[0].order === _SortOrder.ASC
                                    ? 'menu-up'
                                    : 'menu-down'
                            "
                            *ngIf="
                                sortDefs &&
                                sortDefs.length &&
                                sortDefs[0].columnId === c.children[0].id
                            "
                        ></cmps-icon>
                        <cmps-icon
                            svgIcon="menu-swap"
                            *ngIf="
                                !sortDefs ||
                                !sortDefs.length ||
                                sortDefs[0].columnId !== c.children[0].id
                            "
                        ></cmps-icon>
                    </button>
                </div>
            </div>
            <div
                *ngSwitchCase="_ColumnType.PERIOD"
                class="ccg-period-col"
            >
                <span>{{ _i18n._829_WEEK | translate }}:</span>&nbsp;
                <button
                    class="btn bg-transparent p-0 ccg-period"
                    [attr.data-ccg]="'period-' + c.id"
                    [attr.data-e2e]="'button-period-date-range-' + c.id"
                    (click)="_onPeriodClick(c)"
                >
                    <span
                        >{{ ctx.week.startDate | date: 'MMMM dd' }} -
                        {{ ctx.week.endDate | date: 'MMMM dd' }}</span
                    >
                </button>
                <div class="ccg-toggle">
                    <button
                        class="btn bg-transparent p-0"
                        [attr.data-e2e]="'button-toggle-period-' + c.id"
                        (click)="_onTogglePeriodColumnClick(c)"
                    >
                        <cmps-icon
                            [svgIcon]="
                                c.ctx.isExpanded
                                    ? 'chevron-right'
                                    : 'chevron-left'
                            "
                        ></cmps-icon>
                    </button>
                </div>
            </div>
            <div
                *ngSwitchCase="_ColumnType.COACHING_COVERAGE_PERCENT"
                class="ccg-coverage-col"
            >
                <span>{{
                    _i18n._9600_COACHING_COVERAGE_PERCENT | translate
                }}</span>
            </div>
            <div
                *ngSwitchCase="_ColumnType.OBSERVATION_COVERAGE_PERCENT"
                class="ccg-coverage-col"
            >
                <cmps-icon
                    class="mr-1"
                    svgIcon="loupe"
                ></cmps-icon>
                <span>{{
                    _i18n._9601_OBSERVATION_COVERAGE_PERCENT | translate
                }}</span>
            </div>
            <div
                *ngSwitchCase="_ColumnType.COMMITMENT_COVERAGE_PERCENT"
                class="ccg-coverage-col"
            >
                <cmps-icon
                    class="mr-1"
                    svgIcon="folder-account"
                ></cmps-icon>
                <span>{{
                    _i18n._9602_COMMITMENT_COVERAGE_PERCENT | translate
                }}</span>
            </div>
            <div *ngSwitchDefault>
                <!--dummy-->
            </div>
        </div>
    </ng-template>

    <ng-template
        gridContent
        data-type="cell"
        data-id="both"
        let-c="c"
        let-r="r"
        let-ctx="ctx"
    >
        <!--must have single root-->
        <div [ngSwitch]="c.ctx.type">
            <div
                *ngSwitchCase="_ColumnType.NAME"
                class="roster-item"
                [attr.data-e2e]="
                    'generic-rosteritemtype-' +
                    (ctx.user.populationGroup == null ? 'lead' : 'sub')
                "
            >
                <!--maybe make into a component-->
                <div class="name-container">
                    <!--padding-left from .icon-->
                    <div
                        [ngStyle]="{
                            'padding-left':
                                'calc(1.8rem * ' + r.context.ctx.depth + ')'
                        }"
                    ></div>
                    <div class="icon">
                        <button
                            class="btn bg-transparent p-0"
                            (click)="_onToggleRowExpandClick(r.def)"
                            *ngIf="ctx.user.populationGroup == null"
                        >
                            <cmps-icon
                                [svgIcon]="
                                    r.context.ctx.isExpanded
                                        ? 'chevron-down'
                                        : 'chevron-right'
                                "
                            ></cmps-icon>
                        </button>
                    </div>
                    <div class="icon">
                        <cmps-icon
                            class="account-icon"
                            svgIcon="account-circle"
                        ></cmps-icon>
                    </div>
                    <div class="text">
                        <button
                            class="btn bg-transparent p-0 text-left"
                            (click)="_onToggleRowExpandClick(r.def)"
                            *ngIf="
                                ctx.user.populationGroup == null;
                                else textTpl
                            "
                        >
                            <ng-container
                                *ngTemplateOutlet="textTpl"
                            ></ng-container>
                        </button>
                        <ng-template #textTpl>
                            <span class="name">{{ ctx.user.fullName }}</span>
                            <span class="userid">{{ ctx.user.userId }}</span>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div
                *ngSwitchCase="_ColumnType.OA_SCORE"
                class="roster-item"
            >
                <!--maybe make into a component-->
                <div class="info-container">
                    <div
                        class="oa-score"
                        [style.background-color]="ctx.user.oaThreshold"
                    >
                        <span>{{ _i18n._7463_OA | translate }}:&nbsp;</span>
                        <span class="score">{{
                            ctx.user.oaScore / 100 | percent: '1.0-2'
                        }}</span>
                    </div>
                    <!-- Show calendar modal -->
                    <button
                        class="btn bg-transparent p-0 mt-1"
                        (click)="_onScheduleForUserClick(ctx.user)"
                    >
                        <cmps-icon
                            class="mr-1"
                            svgIcon="calendar-range"
                        ></cmps-icon>
                        <span>{{ _i18n._9606_SCHEDULE | translate }}</span>
                    </button>
                </div>
            </div>
            <div
                *ngSwitchCase="_ColumnType.OVERALL_COACHING_PERCENT"
                class="ccg-coverage-cell"
            >
                <span
                    [style.color]="
                        ctx.overall.overallCoveragePct == null
                            ? null
                            : ctx.overall.overallCoachingThresholdColour
                    "
                >
                    {{
                        ctx.overall.overallCoveragePct == null
                            ? '-'
                            : (ctx.overall.overallCoveragePct
                              | percent: '1.0-0')
                    }}
                </span>
            </div>
            <div
                *ngSwitchCase="_ColumnType.COACHING_COVERAGE_PERCENT"
                class="ccg-coverage-cell"
            >
                <span
                    [style.color]="
                        ctx.period.coverageScore == null
                            ? null
                            : ctx.period.coverageColour
                    "
                >
                    {{
                        ctx.period.coverageScore == null
                            ? '-'
                            : (ctx.period.coverageScore | percent: '1.0-0')
                    }}
                </span>
            </div>
        </div>
    </ng-template>

    <ng-template
        gridContent
        data-type="cell"
        data-id="self"
        let-c="c"
        let-ctx="ctx"
    >
        <!--must have single root-->
        <div [ngSwitch]="c.ctx.type">
            <div
                *ngSwitchCase="_ColumnType.OBSERVATION_COVERAGE_PERCENT"
                class="ccg-coverage-cell"
            >
                <span
                    [ngStyle]="{ color: ctx.period.observationCoverageColour }"
                >
                    {{
                        ctx.period.observationCoverageScore == null
                            ? '-'
                            : (ctx.period.observationCoverageScore
                              | percent: '1.0-0')
                    }}
                </span>
            </div>
            <div
                *ngSwitchCase="_ColumnType.COMMITMENT_COVERAGE_PERCENT"
                class="ccg-coverage-cell"
            >
                <span
                    [ngStyle]="{ color: ctx.period.commitmentCoverageColour }"
                >
                    {{
                        ctx.period.commitmentCoverageScore == null
                            ? '-'
                            : (ctx.period.commitmentCoverageScore
                              | percent: '1.0-0')
                    }}
                </span>
            </div>
        </div>
    </ng-template>

    <ng-template
        gridContent
        data-type="cell"
        data-id="team"
        let-c="c"
        let-l="l"
        let-ctx="ctx"
    >
        <!--must have single root-->
        <div [ngSwitch]="c.ctx.type">
            <div
                *ngSwitchCase="_ColumnType.OBSERVATION_COVERAGE_PERCENT"
                [attr.data-ccg]="'schedule-' + c.id + '-' + ctx.user.userId"
                cmpsScheduleCell
                [type]="_EventType.OBSERVATION"
                [schedule]="ctx.schedule"
                (otherClick)="_onOtherScheduleItemsClick(l)"
            ></div>
            <div
                *ngSwitchCase="_ColumnType.COMMITMENT_COVERAGE_PERCENT"
                [attr.data-ccg]="'schedule-' + c.id + '-' + ctx.user.userId"
                cmpsScheduleCell
                [type]="_EventType.COMMITMENT"
                [schedule]="ctx.schedule"
                (otherClick)="_onOtherScheduleItemsClick(l)"
            ></div>
        </div>
    </ng-template>
</div>
